import { render, staticRenderFns } from "./FasceBarra.vue?vue&type=template&id=79fc4854&scoped=true"
import script from "./FasceBarra.vue?vue&type=script&lang=js"
export * from "./FasceBarra.vue?vue&type=script&lang=js"
import style0 from "./FasceBarra.vue?vue&type=style&index=0&id=79fc4854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fc4854",
  null
  
)

export default component.exports